var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M27 10c6.627 0 12 5.373 12 12 0 4.843-2.868 9.015-6.999 10.911L32 36a2 2 0 01-2 2H14a2 2 0 01-2-2V20a2 2 0 012-2l1.683-.001.016-.045C17.36 13.317 21.792 10 27 10zm2.895 10h-15.79v16h15.79V20zM27 12c-4.1 0-7.624 2.468-9.168 6H30a2 2 0 012 2v10.661l.03-.017A9.996 9.996 0 0037 22c0-5.523-4.477-10-10-10z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
